import { useState, useEffect, useContext } from "react";
import { Modal, Button, Accordion } from "react-bootstrap";
import {
  Input,
  TextArea,
  Select,
  TextAreaAdvanced,
  InputSearch,
} from "../../../Layout/Forms/Form";
import { Puff } from "react-loading-icons";
import EventTablesRequest from "./EventTablesRequest";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Slider from "@mui/material/Slider";

const FormTableReservation = ({ show, handleModalhide, info }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    form: {
      price: "",
      phone_number: "",
      owner_name: "",
      owner_email: "",
      observations_public: "",
      observations_private: "",
      payment_type: "total",
      percentage_pre_payment: 100,
    },
    client: {
      name: "",
      url_picture: "",
      phone_number: "",
      email: "",
    },
    errors: [],
  });
  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  useEffect(() => {
    if (show) {
      setState({
        ...state,
        form: {
          ...state.form,
          percentage_pre_payment: parseFloat(info.table.percentage_pre_payment),
          phone_number: "",
          owner_name: "",
          owner_email: "",
        },
        client: {
          name: "",
          url_picture: "",
          phone_number: "",
          email: "",
        },
      });
    }
  }, [show]);

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const handleSubmitForm = async () => {
    if (state.form.phone_number.length <= 0) {
      setState({
        ...state,
        errors: {
          phone_number: ["Campo Obrigatório"],
        },
      });
      return false;
    }
    setIsLoading(true);
    let request = await EventTablesRequest.reserveEventTable({
      ...state.form,
      id_events: info.table.id_events,
      id: info.table.id,
      sendSms: true,
    });
    if (request && request.status) {
      //setState(info.data);
      handleModalhide();
    } else {
      if (request.errors && request.errors.length > 0) {
        alert(request.errors[0]);
      }
      handleModalhide();
    }
    setIsLoading(false);
  };

  const handlerCheckClientExist = async () => {
    if (state.form.phone_number.length <= 0) {
      setState({
        ...state,
        errors: {
          phone_number: ["Campo Obrigatório"],
        },
      });
      return false;
    }

    if (state.form.owner_name.length <= 0) {
      setState({
        ...state,
        errors: {
          owner_name: ["Campo Obrigatório"],
        },
      });
      return false;
    }
    setIsLoading(true);
    let request = await EventTablesRequest.checkClientExist({
      ...state.form,
      id_events: info.table.id_events,
      id: info.table.id,
    });
    if (request && request.status) {
      setState({
        ...state,
        client: request.data,
      });
    }
    setIsLoading(false);
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: "#202634",
      },
      secondary: {
        main: "#11cb5f",
      },
    },
    markLabel: {
      color: "#fff",
    },
  });

  const marksPercentagePrePayment = [
    {
      value: 0,
      label: "0",
    },
    {
      value: 25,
      label: "25",
    },
    {
      value: 50,
      label: "50",
    },
    {
      value: 75,
      label: "75",
    },
    {
      value: 100,
      label: "100",
    },
  ];

  return (
    <>
      <Modal show={show} onHide={handleModalhide}>
        <Modal.Header closeButton>
          <Modal.Title>Reservar mesa</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isLoading ? (
            <InsideLoading />
          ) : (
            <>
              <div className="row">
                <div className="col-12">
                  <div
                    className="block-mesa h-100"
                    style={{ borderLeft: `5px solid ${info.table.color}` }}
                  >
                    <div className="block-content">
                      <div className="block-title">
                        <h3>Mesa: {info.table.name}</h3>
                      </div>
                      <div className="block-details mt-3">
                        {info.table.base_price}
                        <i className="fa-solid fa-euro-sign ms-1 me-2"></i>
                        <i className="fa-solid fa-users ms-2 me-1"></i>
                        {info.table.numberOfGuests}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row mt-2"
                style={{ display: state.client.name ? "none" : "" }}
              >
                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <Input
                        label="Nº Telemóvel Cliente"
                        name="phone_number"
                        value={state.form.phone_number}
                        onChange={(e) => handleChangeInputs(e)}
                        type="number"
                        errors={state.errors}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        label="Nome Cliente"
                        name="owner_name"
                        value={state.form.owner_name}
                        onChange={(e) => handleChangeInputs(e)}
                        errors={state.errors}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <Input
                        label="Email"
                        name="owner_email"
                        value={state.form.owner_email}
                        onChange={(e) => handleChangeInputs(e)}
                        type="text"
                        errors={state.errors}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="row mt-2"
                style={{ display: state.client.name ? "inherit" : "none" }}
              >
                <div className="col-12">
                  <div className="card cards-bg-form">
                    <div className="row p-2">
                      <div className="col-3 col-sm-2">
                        {state.client.image ? (
                          <img
                            src={state.client.image}
                            className="img-fluid"
                            style={{
                              height: "64px",
                              width: "64px",
                              borderRadius: "100px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              height: "64px",
                              width: "64px",
                              borderRadius: "100px",
                              backgroundColor: "#ea2c61",
                            }}
                          >
                            &nbsp;
                          </div>
                        )}
                      </div>
                      <div className="col-9 col-sm-10">
                        <div className="row">
                          <div className="col-12">
                            <span className="fs-3">{state.client.name}</span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <span className="fs-6">
                              {state.client.phone_number}
                            </span>
                          </div>
                          <div
                            className="col-6"
                            style={{ borderLeft: "1px solid #ccc" }}
                          >
                            <span className="fs-6">{state.client.email}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="row mt-3"
                style={{ display: state.client.name ? "initial" : "none" }}
              >
                <div className="col-12">
                  <div className="card cards-bg-form">
                    <h5 className="card-header">
                      <i className="fa-solid fa-money-check-dollar me-3"></i>
                      Pagamento
                    </h5>
                    <div className="card-body">
                      Método pagamento
                      <div className="list-group list-group-radio d-grid gap-2 border-0">
                        <div className="position-relative">
                          <input
                            style={{ zIndex: 999, top: "35%" }}
                            className="form-check-input position-absolute  end-0 me-3 fs-5"
                            type="radio"
                            name="listGroupRadioGrid"
                            id="paumento_method_mbway"
                            value=""
                            onChange={() => false}
                            checked={"checked"}
                          />
                          <label
                            className="list-group-item py-3 pe-5"
                            htmlFor="paumento_method_mbway"
                            style={{
                              backgroundColor: "#0a1116",
                              color: "#dee2e6",
                            }}
                          >
                            <strong className="fw-semibold">
                              <img
                                src="/img/payments/mbway.png"
                                className="img-fluid"
                                style={{ height: "32px", width: "auto" }}
                              />
                            </strong>
                            <span className="mt-1 d-block small opacity-75">
                              Este método de pagamento têm um valor máximo de{" "}
                              <u>750€</u> por transferência imposto pela SIBS.
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-11">
                          <label className="form-label">
                            Percentagem Pré-Pagamento
                          </label>
                          <ThemeProvider theme={theme}>
                            <Slider
                              getAriaLabel={() => "Percentagem Pré-Pagamento"}
                              value={state.form.percentage_pre_payment}
                              name="percentage_pre_payment"
                              onChange={handleChangeInputs}
                              min={25}
                              max={100}
                              step={25}
                              color="primary"
                              valueLabelDisplay="on"
                              marks={marksPercentagePrePayment}
                            />
                          </ThemeProvider>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-5">
                          Valor
                          <div
                            className="p-3 text-end"
                            style={{
                              backgroundColor: "#0d1012",
                              fontSize: "1.3rem",
                              borderRadius: "8px",
                            }}
                          >
                            {(
                              parseFloat(info.table.base_price) *
                              (parseFloat(state.form.percentage_pre_payment) /
                                100)
                            ).toFixed(2)}
                            €
                          </div>
                        </div>
                        <div className="col-7">
                          Valor Total{" "}
                          <span style={{ fontWeight: 200, fontSize: "0.9rem" }}>
                            (Incluí taxa de pagamento)
                          </span>
                          <div
                            className="p-3 text-end"
                            style={{
                              backgroundColor: "#0d1012",
                              fontSize: "1.3rem",
                              borderRadius: "8px",
                            }}
                          >
                            {(
                              parseFloat(info.table.base_price) *
                              (parseFloat(state.form.percentage_pre_payment) /
                                100) *
                              (1 + info.table.transaction_fee / 100)
                            ).toFixed(2)}
                            €
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row mt-4"
                style={{ display: state.client.name ? "initial" : "none" }}
              >
                <div className="col-12">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Obervações</Accordion.Header>
                      <Accordion.Body>
                        <div className="row mt-2">
                          <div className="col-12">
                            <TextArea
                              label="Obervações (Cliente)"
                              name="observations_public"
                              value={state.form.observations_public}
                              rows="4"
                              onChange={(e) => handleChangeInputs(e)}
                              errors={state.errors}
                            />
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-12">
                            <TextArea
                              label="Obervações (Internas)"
                              name="observations_private"
                              value={state.form.observations_private}
                              rows="4"
                              onChange={(e) => handleChangeInputs(e)}
                              errors={state.errors}
                            />
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalhide}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            style={{ display: state.client.name ? "initial" : "none" }}
            onClick={() => handleSubmitForm()}
          >
            Reservar mesa
          </Button>
          <Button
            variant="primary"
            style={{ display: state.client.name ? "none" : "initial" }}
            onClick={() => handlerCheckClientExist()}
          >
            Próximo passo
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FormTableReservation;
